import { ITheme } from './themes/theme';

/* Fundamentals */

// Themes
export type { ITheme, IPublicSiteConfig } from './themes/theme';
export { generateTheme } from './themes/theme';
export * from './themes/EoraThemeProvider';
export * from './themes/themes';

// Common
export * from './common/constants';
export * from './common/utils';
export * from './common/domUtils';
export * from './common/BaseElements';

// Typography
export * from './fundamentals/typography/typography';

// Spaces
export * from './fundamentals/spaces/space';
export * from './fundamentals/spaces/responsive/spaceResponsive';
export * from './fundamentals/spaces/SpaceContainer';
export * from './fundamentals/spaces/responsive/SpaceContainerResponsive';
export * from './fundamentals/spaces/ScrollingContainer';
export * from './fundamentals/spaces/ModuleContainer';

// Colours
export * from './fundamentals/colours/colour';
export * from './fundamentals/colours/variants';
export * from './fundamentals/colours/colourInterfaces';
export { disableUseFilterColourCss } from './fundamentals/colours/filter';

// Blurs
export * from './fundamentals/blurs/blurs';

// Animations
export * from './fundamentals/animations/animations';

// Breakpoints
export * from './fundamentals/breakpoints/breakpoints';

// Sizes
export * from './fundamentals/sizes/sizes';
export * from './fundamentals/sizes/borderRadius';
export * from './fundamentals/sizes/mediaSize';

// Shadows
export * from './fundamentals/shadows/shadows';

// Actions
export * from './fundamentals/actions';

// Numeric
export * from './fundamentals/numeric/Numeric';

/* Components */

// Headings
export * from './components/Headings/Headings';

// Texts
export * from './components/Texts/Texts';

// Texts
export * from './components/Lists/Lists';

// Logo
export * from './components/Logo/Logo';
export * from './components/Logo/HeaderLogo';

// Badge
export { Badge } from './components/Badge/Badge';
export type { IBadgeProps } from './components/Badge/Badge';

export * from './components/DotIcon/DotIcon';

export * from './components/FeaturedIcon/FeaturedIcon';

export * from './components/CountryFlag/CountryFlag';
export * from './components/CountryFlag/countryFlags';

export * from './components/ImageIcon/ImageIcon';
export * from './components/ImageIcon/imageIcons';

// Breadcrumbs
export * from './components/Breadcrumb/Breadcrumb';

// Icon
export * from './components/Icon/Icon';
export * from './components/Icon/icons';
// Alert
export * from './components/Alert/Alert';

// Toast
export * from './components/Toast/Toast';

// AlertProvider
export * from './components/AlertProvider/AlertProvider';

// ToastProvider
export * from './components/ToastProvider/ToastProvider';

// ToastMessageManager
export * from './components/ToastMessageManager/ToastMessageManager';

// SeverityIcon
export * from './components/StatusIcon/StatusIcon';

// CloseButton
export * from './components/CloseButton/CloseButton';

// CloseButtonMini
export * from './components/CloseButtonMini/CloseButtonMini';

// Avatar
export * from './components/Avatar/Avatar';

// Button
export * from './components/Button/Button';
export type { IButtonColours } from './components/Button/buttonThemeConfig';
export { ButtonRoot } from './components/Button/ButtonRoot';
export * from './components/Button/buttonVariants';

// LinkButton
export * from './components/LinkButton/LinkButton';

// IconButton
export * from './components/IconButton/IconButton';

// Callout
export * from './components/Callout/Callout';

// Count
export * from './components/Count/Count';

// Divider
export * from './components/Divider/Divider';

// FiveStar
export * from './components/FiveStar/FiveStar';

// Illustration
export * from './components/Illustration/Illustration';
export * from './components/Illustration/illustrations';

// ProgressBar
export * from './components/ProgressBar/ProgressBar';

// QRCode
export * from './components/QRCode/QRCode';

// Delta
export * from './components/Delta/Delta';

// TriangleIndicator
export * from './components/TriangleIndicator/TriangleIndicator';

// Ellipsis
export * from './components/Ellipsis/Ellipsis';

// Label
export * from './components/Label/Label';

// TextField
export * from './components/TextField/TextField';
export * from './components/TextField/PasswordInput';
export * from './components/TextField/EmailInput';
export * from './components/TextField/DateField';

// TextArea
export * from './components/TextArea/TextArea';

// Pagination
export { Pagination } from './components/Pagination/Pagination';
export type { IPaginationProps } from './components/Pagination/Pagination';

// ChatIcon
export * from './components/ChatIcon/ChatIcon';

// HelpText
export * from './components/HelpText/HelpText';

// ErrorText
export * from './components/ErrorText/ErrorText';

// FileUpload
export * from './components/FileUpload/FileUpload';

// LoadingAnimation
export * from './components/LoadingAnimation/LoadingAnimation';

// Options, Checkbox, Radio, Switch
export * from './components/Options/Options';
export * from './components/Options/Checkbox/Checkbox';
export * from './components/Options/Radio/Radio';
export * from './components/Options/Switch/Switch';

// Tooltip
export { Tooltip } from './components/Tooltip/Tooltip';
export { TooltipArrow } from './components/TooltipArrow/TooltipArrow';
export { TooltipHelpIcon } from './components/Tooltip/TooltipHelpIcon';
export type { ITooltipProps } from './components/Tooltip/TooltipBase';

// ColourFlagSelector
export { ColourFlagSelector } from './patterns/ColourFlagSelector/ColourFlagSelector';
export type { IColourFlagSelectorProps } from './patterns/ColourFlagSelector/ColourFlagSelector';

// Noticebar
export * from './components/Noticebar/Noticebar';
export * from './components/NoticebarProvider/NoticebarProvider';

// Select
export * from './components/Select/Select';
export * from './components/Select/SelectAsync';
export * from './components/Select/selectHelpers';
export * from './components/Select/SelectComponents';

// ButtonGroup
export * from './patterns/ButtonGroup/ButtonGroup';

// Menu
export * from './patterns/Menu/Menu';
export * from './patterns/MenuItem/MenuItem';
export * from './patterns/MenuItem/MenuItemPopper';

// Modal
export * from './patterns/Modal/Modal';

// Phoenix Modal Provider
export * from './phoenix/PhoenixModalProvider/PhoenixModalProvider';

// Splash Screen
export * from './patterns/SplashScreen/SplashScreen';

// MoreLink
export * from './components/MoreLink/MoreLink';

// BackNextButton
export * from './components/BackNextButton/BackNextButton';

// Overlay
export * from './components/Overlay/Overlay';

// TourModal
export * from './patterns/TourModal/TourModal';

// TourModal Steps
export { EVENTS } from './patterns/TourModal/tourModal.common';
export type { IStep, IStepConfig } from './patterns/TourModal/tourModal.common';

// VideoPlayer
export * from './patterns/VideoPlayer/VideoPlayer';

// VerificationCode
export * from './components/VerificationCode/VerificationCode';

// Dropdown
export * from './patterns/Dropdown/Dropdown';
export * from './patterns/Dropdown/DropdownMenu';
export * from './patterns/Dropdown/DropdownToggle';
export * from './patterns/DropdownItem/DropdownBaseItem';
export * from './patterns/DropdownItem/DropdownItem';
export * from './patterns/Dropdown/useDropdown';

// Country Dropdown
export * from './patterns/CountryDropdown/CountryDropdownMenu';
export * from './patterns/CountryDropdown/CountryDropdownToggle';

// Sheet
export * from './components/Sheet/Sheet';

// Accordion
export * from './components/Accordion/Accordion';

// Table
export * from './components/Table/Table';
export * from './components/Table/TableSort';

// Tabs
export * from './components/Tabs/Tabs';
export * from './components/Tabs/Tab';
export * from './components/Tabs/TabPanel';
export * from './components/Tabs/TabList';
export * from './components/Tabs/TabsContext';

// CtaButtonBar
export * from './components/CtaButtonBar/CtaButtonBar';

// Card
export * from './patterns/Card/Card';

// EmptyCard
export * from './patterns/EmptyCard/EmptyCard';

// Cell
export * from './patterns/Cell/Cell';

// ProgressIndicator
export * from './patterns/ProgressIndicator/ProgressIndicator';
export * from './patterns/ProgressIndicator/ProgressIndicatorContext';
export * from './patterns/ProgressIndicator/ProgressIndicatorStep';

// Spark
export * from './components/Spark/Spark2';
export type { ILineData } from './components/Spark/SparkBase';

// MiniModal
export * from './patterns/MiniModal/MiniModal';

// DateDisplay
export * from './components/DateDisplay/DateDisplay';

// HorizontalScroll
export * from './components/HorizontalScroll/Arrows';
export * from './components/HorizontalScroll/HorizontalScroll';
export * from './components/HorizontalScroll/HorizontalScrollContainer';

// Skeleton
export * from './components/Skeleton/Skeleton';

// SkeletonCell
export * from './patterns/SkeletonCell/SkeletonCell';

// Metric
export * from './patterns/Metric/Metric';

// Tile
export * from './patterns/Tile/Tile';

// Interceptor
export * from './patterns/Interceptor/Interceptor';

// Bullet
export * from './patterns/Tile/Bullet';

// Carousel
export * from './patterns/Carousel/Carousel';

// DO NOT REMOVE LINE - COMPONENT_EXPORTS

/* Hooks */
export * from './hooks/useTestId/useTestId';

export * from './hooks/useTargetId/useTargetId';

export * from './hooks/useResponsive/useResponsive';

export * from './hooks/useAlertState/useAlertState';

export * from './hooks/useIsScrolling/useIsScrolling';

export * from './hooks/useEditContext/useEditContext';

export * from './hooks/useMobileDetect/useMobileDetect';

// Validators
export * from './hooks/useValidator/useInputValidator';
export * from './hooks/useValidator/useValidator';
export * from './validators/validator';

export * from './hooks/useFileUpload/useFileUpload';

export * from './hooks/useDateDisplay/useDateDisplay';

// Assets config
export * from './config';

// Vendor libraries
export * from './vendor/mac-scrollbar';

// https://styled-components.com/docs/api#create-a-declarations-file
// include here so package users get this too
declare module 'styled-components' {
  export interface DefaultTheme extends ITheme {}
}
